<template>
  <div>
    <Loading v-if="loading" :loading="loading" />
    <div style="padding: 0 20px 30px 20px;" v-else>
      <!-- 行为分析 -->
      <ProgressAnalyse :mitre="mitre" id="progressanalyse" v-if="progressanalyse" :progressanalyse="progressanalyse" />
    </div>
    <detail-footer/>
  </div>
</template>

<script>
import {
  getTaskReportOverview,
  getTaskReportBehaviorProcess,
  getTaskReportBehaviorNetwork,
  getTaskReportDropped
} from 'services/report'
import ProgressAnalyse from '../ProgressAnalyse'
import { resetTransition } from '@/hooks/useDom'
import { isZh } from 'app/i18n'

export default {
  name: 'behavior',
  components: {
    ProgressAnalyse
  },
  data () {
    return {
      progressanalyse: {},
      loading: true
    }
  },
  props: {
    mitre: {
      type: Array
    }
  },
  computed: {
    taskId () {
      return this.$route.params.taskId
    }
  },
  methods: {
    async init () {
      await getTaskReportOverview(this.taskId).then(res => {
        this.progressanalyse.info = res.info
        this.progressanalyse.target = res.target
      })
      await getTaskReportBehaviorProcess(this.taskId).then(res => {
        this.progressanalyse.process_tree = res.processtree
        this.progressanalyse.processes = res.processes
        this.progressanalyse.events_map = res.events_map
      })
      await getTaskReportBehaviorNetwork(this.taskId, {
        lang: isZh() ? 'zh' : 'en'
      }).then(res => {
        this.progressanalyse.domains = res.domains
        this.progressanalyse.hosts = res.hosts
        this.progressanalyse.https = res.https
        this.progressanalyse.http = res.http
      })
      await getTaskReportDropped(this.taskId).then(res => {
        this.progressanalyse.dropped = res.dropped
      })
      this.loading = false
      resetTransition()
    }
  },
  mounted () {
    console.log('init')
    this.init()
  }
}
</script>

<style lang="stylus" scoped>
</style>
